import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import SimpleLayout from './layouts/simple';
import UserPage from './pages/UserPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import DashboardAppPage from './pages/DashboardAppPage';

// ----------------------------------------------------------------------
import PrivateRoute from './PrivateRoute';
// import DashboardLayout from './layouts/dashboard/DashboardLayout';
import MemberViewPage from './pages/MemberViewPage';
import MemberEditPage from './pages/MemberEditPage';
import MemberAttendance from './pages/MemberAttendance';
import Settings from './sections/@Users/settings/Settings';
import Profile from './sections/@Users/profile/Profile';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: <PrivateRoute />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: 'app', element: <DashboardAppPage /> },
        { path: 'members', element: <UserPage /> },
        { path: 'members/:memberId/memberview', element: <MemberViewPage /> },
        { path: 'members/:memberId/memberedit', element: <MemberEditPage /> },
        { path: 'attendance', element: <MemberAttendance /> },
      ],
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      path: 'forgot-password',
      element: <ForgotPassword />,
    },
    {
      path: 'reset-password',
      element: <ResetPassword />,
    },
    {
      path: 'users',
      element: <PrivateRoute />,
      children: [
        { path: 'settings', element: <Settings /> },
        { path: 'profile', element: <Profile /> },
      ],
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/login" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
